import { Party } from "./party";

export class Shipment {
  constructor(
    private _type: string = null,
    private _id: string = null,
    private _from: Party = null,
    private _to: Party = null,
    private _idOrders: string[] = [],
    private _state: string = null,
    private _totalPackages: number = null,
    private _weight: number = null,
    private _creationDate: Date = null,
    private _shipmentNumber: string = null,
    private _shipmentType: string = null,
    private _pickupCode: string = null,
    private _generatePdf: string = null
  ) { }

  get type(): string {
    return this._type;
  }

  get id(): string {
    return this._id;
  }

  get from(): Party {
    return this._from;
  }

  get to(): Party {
    return this._to;
  }

  get idOrders(): string[] {
    return this._idOrders;
  }

  get state(): string {
    return this._state;
  }

  get totalPackages(): number {
    return this._totalPackages;
  }

  get weight(): number {
    return this._weight;
  }

  get creationDate(): Date {
    return this._creationDate;
  }

  get shipmentNumber(): string {
    return this._shipmentNumber;
  }

  get fromFullAddress() {
    return this._from.refNameFullAddress;
  }

  get toFullAddress() {
    return this._to.refNameFullAddress;
  }

  get pickupCode(): string {
    return this._pickupCode;
  }

  get shipmentType(): string {
    return this._shipmentType;
  }

  get generatePdf(): string {
    return this._generatePdf;
  }

  static fromRaw(data: any): Shipment {
    return new Shipment(
      null,
      data.key,
      Party.fromRawShipment(data.data.from),
      Party.fromRawShipment(data.data.to),
      data.data.id_orders,
      data.data.state,
      data.data.total_packages,
      data.data.weight,
      new Date(data.data.creation_date._seconds * 1000),
      data.data.shipment_number,
      data.data.shipment_type,
      data.data.pickup_code,
      data.data.generate_pdf
    )
  }

  withType(type: string): Shipment {
    return new Shipment(
      type,
      this._id,
      this._from,
      this._to,
      this._idOrders,
      this._state,
      this._totalPackages,
      this._weight,
      this._creationDate,
      this._shipmentNumber,
      this._shipmentType,
      this.pickupCode,
      this.generatePdf
    );
  }

  withSender(sender: Party): Shipment {
    return new Shipment(
      this._type,
      this._id,
      sender,
      this._to,
      this._idOrders,
      this._state,
      this._totalPackages,
      this._weight,
      this._creationDate,
      this._shipmentNumber,
      this._shipmentType,
      this.pickupCode,
      this.generatePdf
    )
  }

  withReceiver(receiver: Party): Shipment {
    return new Shipment(
      this._type,
      this._id,
      this._from,
      receiver,
      this._idOrders,
      this._state,
      this._totalPackages,
      this._weight,
      this._creationDate,
      this._shipmentNumber,
      this._shipmentType,
      this.pickupCode,
      this.generatePdf
    )
  }

  withSelectedOrder(idOrder: string): Shipment {
    this._idOrders = [idOrder];
    return new Shipment(
      this._type,
      this._id,
      this._from,
      this._to,
      this._idOrders,
      this._state,
      this._totalPackages,
      this._weight,
      this._creationDate,
      this._shipmentNumber,
      this._shipmentType,
      this.pickupCode,
      this.generatePdf
    )
  }

  withId(id: string): Shipment {
    return new Shipment(
      this._type,
      id,
      this._from,
      this._to,
      this._idOrders,
      this._state,
      this._totalPackages,
      this._weight,
      this._creationDate,
      this._shipmentNumber,
      this._shipmentType,
      this.pickupCode,
      this.generatePdf
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/shipment.ts